// useFeatureFlag hook — wraps PostHog feature flags with a safe fallback when PostHog is not configured.
import { useEffect, useState } from 'react';
import { ph } from '../lib/posthog';

/**
 * Returns the active variant for a multivariate feature flag, or the fallback when PostHog is not initialized.
 * Usage: const variant = useFeatureFlag('hero_cta_color', 'control');
 */
export function useFeatureFlag(flagKey, fallback = 'control') {
  const [variant, setVariant] = useState(() => {
    if (typeof window === 'undefined') return fallback;
    const client = ph();
    if (!client) return fallback;
    const v = client.getFeatureFlag(flagKey);
    return v === undefined || v === null || v === false ? fallback : v;
  });

  useEffect(() => {
    const client = ph();
    if (!client) return undefined;
    const handler = () => {
      const v = client.getFeatureFlag(flagKey);
      setVariant(v === undefined || v === null || v === false ? fallback : v);
    };
    client.onFeatureFlags(handler);
    return undefined;
  }, [flagKey, fallback]);

  return variant;
}
